module.exports = __webpack_public_path__ + "img/Affiliates.55edc592.png";